import api from './client';

export interface LoginPayload { email: string; password: string }
export interface RegisterPayload { name: string; email: string; password: string; companyName: string; companySlug: string }

export const authApi = {
  login: (data: LoginPayload) => api.post('/auth/login', data),
  register: (data: RegisterPayload) => api.post('/auth/register', data),
  refresh: (refreshToken: string) => api.post('/auth/refresh', { refreshToken }),
  logout: (refreshToken: string) => api.post('/auth/logout', { refreshToken }),
  me: () => api.get('/auth/me'),
  githubAuth: () => { window.location.href = '/api/v1/auth/github'; },
};

export const usersApi = {
  list: (params?: Record<string, unknown>) => api.get('/users', { params }),
  invite: (data: unknown) => api.post('/users/invite', data),
  getOne: (id: string) => api.get(`/users/${id}`),
  updateRole: (id: string, role: string) => api.patch(`/users/${id}/role`, { role }),
  deactivate: (id: string) => api.delete(`/users/${id}`),
};

export const companyApi = {
  get: () => api.get('/company'),
  update: (data: unknown) => api.patch('/company', data),
  stats: () => api.get('/company/stats'),
  listApiKeys: () => api.get('/company/api-keys'),
  createApiKey: (name: string) => api.post('/company/api-keys', { name }),
  revokeApiKey: (id: string) => api.delete(`/company/api-keys/${id}`),
};

export const revenueApi = {
  list: (params?: Record<string, unknown>) => api.get('/revenue', { params }),
  get: (id: string) => api.get(`/revenue/${id}`),
  create: (data: unknown) => api.post('/revenue', data),
  update: (id: string, data: unknown) => api.patch(`/revenue/${id}`, data),
  delete: (id: string) => api.delete(`/revenue/${id}`),
  analytics: (params?: Record<string, unknown>) => api.get('/revenue/analytics', { params }),
  listLeakages: (params?: Record<string, unknown>) => api.get('/revenue/leakages', { params }),
  createLeakage: (data: unknown) => api.post('/revenue/leakages', data),
  resolveLeakage: (id: string) => api.post(`/revenue/leakages/${id}/resolve`),
  deleteLeakage: (id: string) => api.delete(`/revenue/leakages/${id}`),
};

export const billingApi = {
  getSubscription: () => api.get('/billing/subscription'),
  getInvoices: () => api.get('/billing/invoices'),
  createCheckout: (plan: string) => api.post('/billing/checkout', { plan }),
  createPortal: () => api.post('/billing/portal'),
};

export const integrationsApi = {
  githubStatus: () => api.get('/integrations/github/status'),
  githubDisconnect: () => api.delete('/integrations/github'),
  githubRepos: () => api.get('/integrations/github/repos'),
};
